import {svgIconWrapper} from '../svg-icon-wrapper';

import BulletListRegular from './bullet-list-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <BulletListRegular {...validProps} />;
}
SvgComponent.iconName = 'bulletListRegular';

export const BulletListRegularIcon = svgIconWrapper(SvgComponent);
